document.addEventListener('DOMContentLoaded', function () {
  /* ---------------- Tabs ---------------- */
  document.querySelectorAll('.hd-tabs').forEach(function (root) {
    var buttons = root.querySelectorAll('.hd-tabs__btn');
    var panels = root.querySelectorAll('.hd-tabs__panel');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-target');

        buttons.forEach(function (b) {
          var isActive = b === btn;
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
          b.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach(function (p) {
          var match = p.getAttribute('data-panel') === target;
          p.setAttribute('data-active', match ? 'true' : 'false');
          p.toggleAttribute('hidden', !match);
        });
      });
    });
  });

  /* ---------------- Scroll reveal (respects reduced motion) ---------------- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var revealTargets = document.querySelectorAll('.hd-reveal');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealTargets.forEach(function (el) { observer.observe(el); });
  } else {
    document.querySelectorAll('.hd-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }
});
